<template>
  <v-container>
    <v-layout row align-content-start>
      <v-flex class="pr-2" xs4>
        <PassengerSelectField
          type="Adults"
          :v="v"
          desc="12+ yr"
          field="pax_a_r"
          icon="person"
          :min="1"
          :max="9"
        />
      </v-flex>
      <v-flex class="pr-2" xs4>
        <PassengerSelectField
          type="Children"
          :v="v"
          desc="2-11 yr"
          field="pax_c_r"
          icon="child_care"
          :min="0"
          :max="9"
        />
      </v-flex>
      <v-flex xs4>
        <PassengerSelectField
          type="Infants"
          :v="v"
          desc="0-23 mo"
          field="pax_i_r"
          icon="child_friendly"
          :min="0"
          :max="9"
        />
      </v-flex>
      <v-spacer grow></v-spacer>
    </v-layout>
  </v-container>
</template>

<script>
import PassengerSelectField from "@/components/forms/sections/PassengerSelectField.vue";
import { createHelpers } from "vuex-map-fields";
import Shared from "@/mixins/Shared";

const { mapFields } = createHelpers({
  getterType: "getField",
  mutationType: "updateField"
});

export default {
  name: "PassengerSelectReturn",
  props: ["v"],
  computed: {
    ...mapFields([
      "form_fields.pax_a_r",
      "form_fields.pax_c_r",
      "form_fields.pax_i_r"
    ])
  },
  mixins: [Shared],
  components: { PassengerSelectField },
  data: () => ({
    paxA: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    pax: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
  })
};
</script>
